<!--
 * @ Author: Your name
 * @ Create Time: 2019-05-30 15:01:41
 * @ Modified by: Your name
 * @ Modified time: 2019-05-30 15:40:56
 * @ Description: 这是一个提示框，用于新增、修改等操作前的询问弹窗
 -->

<template>
  <el-dialog
    title="提示"
    :visible.sync="handleDialogVisible"
    width="30%"
    >
    <p class="btn-tip"><i class="el-icon-warning"></i>{{handleBtnTip}}</p>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleDialogClose()" size="small" type="info">取 消</el-button>
      <el-button @click="handleDialogComfirm()" size="small" type="primary">确定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'dialogTip',
  props: {
    handleDialogVisible: {
      type: Boolean,
      default: false
    },
    handleBtnTip: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleDialogComfirm() {
      this.$emit('handleDialogComfirm')
    },
    handleDialogClose() {
      this.$emit('handleDialogClose')
    }
  }
}
</script>
